<template>
  <div class="distance-calculator-container">
    <div>
      <div class="error">{{ error}}</div>
      <h2>Véhicules légers</h2>
      <div class="row align-form">
          <div v-for="(vehicule, index) in vehicules" :key="index" class="col-50">
            <div >
              <DistanceCalculatorInput :vehicule="vehicule" v-model="results[vehicule.type]" @update:modelValue="checkError();$emit('update:modelValue', results);"></DistanceCalculatorInput>
            </div>
          </div>
      </div>
    </div>
    <div>
      <h2>Transports en commun</h2>
      <p class="paragraph">Dans le cas où plus d’une personne participant au voyage utilise le transport collectif,
        il faut additionner
        les kilomètres de chaque passager. (exemple : 200 km parcourus et 3 personnes à bord = 600 km).</p>
        <div class="row align-form">
          <div class="col-50"><DistanceCalculatorInput :vehicule="transportCommun" v-model="results['Autobus urbain ou interurbain']" @update:modelValue="checkError();$emit('update:modelValue', results);"></DistanceCalculatorInput></div>
          <div class="col-50"><DistanceCalculatorInput :vehicule="plane" :plane="true" v-model="results['Avion']" @update:modelValue="checkError();$emit('update:modelValue', results);"></DistanceCalculatorInput></div>
        </div>
    </div>
  </div>
</template>
<script>
import DistanceCalculatorInput from '@/components/form/DistanceCalculatorInput.vue'
export default {
  data() {
    return {
      results:{},
      error:null,
      vehicules: [
        {
          type: 'Voiture',
          icon: require('@/assets/images/transport_sous compacte.png'),
          factor: 0.22
        },
        {
          type: 'VUS et pickup',
          icon: require('@/assets/images/transport_grand-suv-pickup.png'),
          factor: 0.29
        },
        {
          type: 'Voiture hybride branchable',
          icon: require('@/assets/images/transport_hybride.png'),
          factor: 0.07
        },
        {
          type: 'Voiture électrique',
          icon: require('@/assets/images/transport_electrique.png'),
          factor: 0.000001
        },
        {
          type: 'Moto',
          icon: require('@/assets/images/moto.png'),
          factor: 0.13
        },
        {
          type: 'Véhicule avec roulotte',
          icon: require('@/assets/images/transport_roulotte.png'),
          factor: 0.40
        },
        {
          type: 'VR petite taille',
          icon: require('@/assets/images/transport_vr_petit.png'),
          factor: 0.40
        }, 
        {
          type: 'VR grande taille',
          icon: require('@/assets/images/transport_vr_grand.png'),
          factor: 0.72
        }      
      ],
      transportCommun: {
          type: 'Autobus urbain ou interurbain',
          icon: require('@/assets/images/transport_bus.png'),
          factor: 0.06
      },
      plane: {
          type: 'Avion',
          icon: require('@/assets/images/transport_avion.png'),
          factor: 0.228
      }
    }
  },
  methods:{
    checkError(){
      Object.keys(this.results).forEach(element=>{
        let noData=true
        Object.keys(this.results[element]).forEach(element2=>{
          if(element2!=='factor'){
            if(this.results[element][element2] && this.results[element][element2]!==''){
            noData=false
          }
          }

        })
        if(noData){
          this.error = 'Remplissez au moins une case'
          this.$emit('onError', true)
        }
        else{
          this.error = null
          this.$emit('onError', false)
        }
      })
    }
  },
  props:{
    modelValue: Object
  },
  components: {
    DistanceCalculatorInput
  },
  watch: {
    modelValue(newVal) {
      this.results = newVal;
    }
  }
}
</script>
<style scoped>
.distance-calculator-container {
  position: relative;
  background-color: white;
  border-bottom-right-radius: 50px;
  box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
  padding: 36px 56px;
}

.distance-calculator-container h2 {
  color: var(--text-color);
  font-family: var(--font);
  font-size: 60px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
@media screen and (max-width: 1500px) {
  .distance-calculator-container h2 {
    font-size: 45px !important;
  }
}
@media screen and (max-width: 1300px) {
  .distance-calculator-container h2 {
    font-size: 30px !important;
  }
  .align-form{
    align-items:flex-start !important;
  }
}

@media screen and (max-width: 750px) {
  .col-50{
    width:100%;
  }
  .align-form{
    align-items:flex-start !important;
  }
}
@media screen and (max-width: 600px) {
  .distance-calculator-container h2 {
    font-size: 25px;
  }
  .distance-calculator-container {
    padding: 5px 10px;
  }
  .label-calculators{
    font-size: 20px;
  }
}
</style>